import { defineMessages } from 'react-intl';

const messages = defineMessages({
  name: {
    description: 'Fulfillment Provider List Header Row Name',
    defaultMessage: 'Name',
    id: 'ag6lLJ',
  },
  email: {
    description: 'Fulfillment Provider List Header Row Email',
    defaultMessage: 'Email',
    id: '8tHpbN',
  },
  status: {
    description: 'Fulfillment Provider List Header Row Status',
    defaultMessage: 'Status',
    id: 'eVS0k6',
  },
  sharedServices: {
    description: 'Fulfillment Provider List Header Row Shared Services',
    defaultMessage: 'Shared Services',
    id: 'INW+Xx',
  },
  packingSlipSharing: {
    description: 'Fulfillment Provider List Header Row Packing Slip Sharing',
    defaultMessage: 'Packing Slip Sharing',
    id: 'gj9lsB',
  },
  actions: {
    description: 'Fulfillment Provider List Header Row Settings',
    defaultMessage: 'Actions',
    id: 'TseWNl',
  },
});

export default messages;
